import React from 'react';

import Button from 'devextreme-react/button';
import CheckBox from 'devextreme-react/check-box';
import Switch from 'devextreme-react/switch';

import DataModelView from '../common/view/DataModelView';
import { DateViewMode } from '../common/value-types/DateViewMode';

import ScheduleDateView from './views/ScheduleDateView';

export default class ScheduleSideBar extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'isEditingEnabled',
      'isModified',
      'hasValidationErrors',
      'isOperationInProgress',
      'showEditMode',
      'currentMonth',
      'currentDate',
      'useSelectionEditMode',
      'showPastDays',
      'canUserManageColumnPreferences',
      'dateViewMode',
      'resubmitContracts',
      'recalculateContracts'
    ];
  }

  render() {
    return (
      <div>
        <table align="center"><tbody><tr>
          <td className="pwx-datebox-container">
            <ScheduleDateView
              dateViewMode={this.state.dateViewMode}
              onCurrentMonthChanged={this.onDateBoxValueChanged.bind(this)}
              currentDate={this.state.currentDate}
              currentMonth={this.state.currentMonth}
              locale={this.props.locale}
            />
          </td>
          <td className="pwx-spacer-container" />
          <td className="pwx-refresh-container">
            <Button
              type="normal"
              icon="refresh"
              hint="Refresh Current View"
              onClick={this.dataModel.fullRefresh}
              disabled={this.state.isOperationInProgress}
            />
          </td>
        </tr></tbody></table>
        <div className="pwx-summary-sidebar">
          <Switch
            switchedOffText="Direct Entry"
            switchedOnText="Selection"
            value={this.state.useSelectionEditMode}
            onValueChanged={this.onUseSelectionEditModeChanged.bind(this)}
            visible={this.state.showEditMode}
            disabled={this.state.isOperationInProgress}
          />
          {this.props.renderUsageSummaries()}
          <table className="pwx-horiz-center"><tbody>
            <tr>
              <td className="pwx-button-container">
                <Button
                  text="Submit"
                  type="success"
                  icon="upload"
                  visible={this.state.isEditingEnabled}
                  onClick={this.dataModel.submitChanges}
                  disabled={this.state.isOperationInProgress || !this.state.isModified || this.state.hasValidationErrors}
                />          
              </td>
              <td className="pwx-button-spacer" />
              <td className="pwx-button-container">
                <Button
                  text="Revert"
                  type="default"
                  icon="revert"
                  visible={this.state.isEditingEnabled}
                  onClick={this.dataModel.revertChanges}
                  disabled={this.state.isOperationInProgress || !this.state.isModified}
                />
              </td>
            </tr>
          </tbody></table>
          <table className="pwx-horiz-center"><tbody>
            <tr>
              <td className="pwx-button-container">
                <Button
                  text="Export to Excel..."
                  type="default"
                  stylingMode="outlined"
                  icon="export"
                  onClick={this.dataModel.exportToExcel}
                  disabled={this.state.isOperationInProgress}
                />
              </td>
            </tr>
          </tbody></table>
          <table className="pwx-horiz-center"><tbody>
            <tr>
              <td className="pwx-button-container">
                <Button
                  text="Resubmit"
                  type="danger"
                  stylingMode="contained"
                  icon="upload"
                  onClick={this.dataModel.resubmitValues}
                  disabled={this.state.isOperationInProgress}
                  visible={this.state.resubmitContracts.length > 0}
                />
              </td>
              <td className="pwx-button-spacer" />
              <td className="pwx-button-container">
                <Button
                  text="Recalculate"
                  type="default"
                  icon="datafield"
                  onClick={this.dataModel.recalculateValues}
                  disabled={this.state.isOperationInProgress}
                  visible={this.state.recalculateContracts.length > 0}
                />
              </td>
            </tr>
          </tbody></table>
          <table className="pwx-horiz-center" width="100%"><tbody>
            <tr>
              <td className="pwx-button-container" align="left">
                <CheckBox
                  text="Show Past Days"
                  value={this.state.showPastDays}
                  onValueChanged={this.onShowPastDaysChanged.bind(this)}
                  disabled={this.state.isOperationInProgress}
                />
              </td>
              <td className="pwx-button-spacer" />
              <td className="pwx-user-preferences-container" align="right">
                <Button
                  type="normal"
                  icon="group"
                  hint="Manage Default Column Preferences"
                  onClick={this.dataModel.showManageColumnPreferences}
                  visible={this.state.canUserManageColumnPreferences}
                />
              </td>
            </tr>
          </tbody></table>
        </div>
        {this.props.renderContractLimitsView()}
        {this.props.renderMemoView()}
      </div>
    );
  }

  onDateBoxValueChanged(event) {
    if (this.dataModel.dateViewMode !== DateViewMode.fullMonth)
      return;

    this.dataModel.updateProperties({
      currentMonth: event.value
    });

    this.dataModel.fullRefresh();
  }

  onUseSelectionEditModeChanged(event) {
    this.dataModel.updateProperties({
      useSelectionEditMode: event.value
    });

    this.dataModel.enactEditMode();
  }

  onShowPastDaysChanged(event) {
    this.dataModel.updateProperties({
      showPastDays: event.value
    });

    this.dataModel.gridFiltersChanged();
  }
}
